import React, { useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import user from "../assets/images/user.png";
import dropdown from "../assets/images/dropdown.png";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import storageService from "../services/Storage";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { SpinnerCircular } from "spinners-react";

function DropdownRight(props) {
  const [showModal, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setError("");
  };
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [uploadSpin, setUploadSpin] = useState(false);

  const token = GetStorage.get("xAuthToken");

  // const usera = useSelector((state) => state.user.data);
  // console.log("redux user", usera);

  const initialValues = {
    email: "",
    password: "",
  };
  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email format").required("Required"),
    password: Yup.string()
      .required("required")
      .min(5, "Password is too short - should be 5 chars minimum."),
  });
  const onSubmit = async (values, { resetForm }) => {
    setUploadSpin(true);
    http
      .post(`api/admin?token=${token}`, {
        email: values.email,
        password: values.password,
      })
      .then((res) => {
        console.log("added new user", res.data);
        setUploadSpin(false);

        resetForm();
        handleClose();
      })
      .catch((error) => {
        setUploadSpin(false);

        if (error.response) {
          setUploadSpin(false);

          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  let user = localStorage.getItem("user");

  user = JSON.parse(user);

  const signOutUser = () => {
    try {
      storageService.remove("user");
      storageService.remove("xAuthToken");
      storageService.remove("xAuth");

      navigate("/");
    } catch (e) {
      console.log("logout error", e);
    }
  };

  const PermissionPage = () => {
    navigate("/permissions");
  };
  const ApplicantsPage = () => {
    navigate("/application");
  };

  return (
    <>
      <div className="user_profile   ">
        <div className="collapse navbar-collapse show" id="navbar-list-4">
          <Dropdown className="navbar-nav">
            <Dropdown.Toggle>
              <a
                className="nav-link dropdown-toggle"
                // href="#"
                id="navbarDropdownMenuLink"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {user?.img ? (
                  <img
                    style={{}}
                    src={user?.data.img}
                    className="user_profile_img"
                  />
                ) : (
                  <p style={{ display: "inline-block", color: "black" }}>
                    {user?.data.email}
                  </p>
                )}
                <img src={dropdown} className="ml-2 user_profile_icon" />{" "}
              </a>
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="dropdown-menu"
              aria-labelledby="navbarDropdownMenuLink"
            >
              <Dropdown.Item className="dropdown-item" onClick={handleShow}>
                New Admin
              </Dropdown.Item>

              <Dropdown.Item className="dropdown-item" onClick={PermissionPage}>
                Permissions
              </Dropdown.Item>

              <Dropdown.Item className="dropdown-item" onClick={ApplicantsPage}>
                Applicants
              </Dropdown.Item>

              {/* <Dropdown.Item ClassName="dropdown-item" href="/application">
        Applicants
      </Dropdown.Item> */}

              <Dropdown.Item
                ClassName="dropdown-item"
                onClick={() => signOutUser()}
              >
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      {/*  <Modal show={showModal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Create new admin</Modal.Title>
          <button
            onClick={handleClose}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            {" "}
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, handleChange, handleBlur, handleSubmit }) => (
              <>
                <div className="modal-body">
                
                  <div className="form-group  mt-3">
                    <input
                      type="email"
                      name="email"
                      onChange={handleChange("email")}
                      onBlur={handleBlur("email")}
                      value={values.email}
                      className="custom_input form-control"
                      placeholder="Email ID"
                    />{" "}
                    <ErrorMessage name="email" />
                  </div>
                  <div className="form-group  mt-3">
                    <input
                      type="password"
                      name="password"
                      onChange={handleChange("password")}
                      onBlur={handleBlur("password")}
                      value={values.password}
                      className="custom_input form-control"
                      placeholder="Password"
                    />{" "}
                    <ErrorMessage name="password" />
                  </div>
                  <div style={{ padding: 2, marginLeft: 40 }}>
                    <h6 style={{ color: "red", alignSelf: "center" }}>
                      {error}
                    </h6>
                  </div>
                  <div className="modal-footer border-top-0">
                    {" "}
                    <button
                      type="button"
                      className="them_btn_ouline "
                      onClick={handleClose}
                    >
                      Cancel
                    </button>{" "}
                    <button
                      type="button"
                      className="them_btn "
                      onClick={handleSubmit}
                    >
                      {uploadSpin ? (
                        <SpinnerCircular className="button-spin" />
                      ) : (
                        " Send Invite"
                      )}
                    </button>{" "}
                  </div>
                </div>
              </>
            )}
          </Formik>
        </Modal.Body>
      </Modal> */}

      <Modal className="starrating" show={showModal} onHide={handleClose}>
        <Modal.Header
        // className="admin-header"
        >
          <Modal.Title as="h5">Create new admin</Modal.Title>
          <button
            onClick={handleClose}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            {" "}
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </Modal.Header>
        <Modal.Body
        // style={{ backgroundColor: "#f6f6f6" }}
        >
          <div class="raing_star">
            <p>Please enter your login credentials to proceed</p>
          </div>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, handleChange, handleBlur, handleSubmit }) => (
              <>
                <div className="form-group  mt-3">
                  <input
                    type="email"
                    name="email"
                    onChange={handleChange("email")}
                    onBlur={handleBlur("email")}
                    value={values.email}
                    className="custom_input w-100 form-control"
                    placeholder="Email ID"
                  />{" "}
                  <div
                    style={{
                      color: "red",
                      textAlign: "center",
                    }}
                  >
                    <ErrorMessage name="email" />
                  </div>
                </div>
                <div className="form-group  mt-3">
                  <input
                    type="password"
                    name="password"
                    onChange={handleChange("password")}
                    onBlur={handleBlur("password")}
                    value={values.password}
                    className="custom_input  w-100 form-control"
                    placeholder="Password"
                  />{" "}
                  <div
                    style={{
                      color: "red",
                      textAlign: "center",
                    }}
                  >
                    <ErrorMessage name="password" />
                  </div>
                </div>
                <div style={{ padding: 2, marginLeft: 40 }}>
                  <h6 style={{ color: "red", alignSelf: "center" }}>{error}</h6>
                </div>
                {/*  <div className="modal-footer border-top-0">
                    {" "}
                    <button
                      type="button"
                      className="them_btn_ouline "
                      onClick={handleClose}
                    >
                      Cancel
                    </button>{" "}
                    <button
                      type="button"
                      className="them_btn "
                      onClick={handleSubmit}
                    >
                      {uploadSpin ? (
                        <SpinnerCircular className="button-spin" />
                      ) : (
                        " Send Invite"
                      )}
                    </button>{" "}
                  </div> */}

                <div className="modal-footer border-top-0">
                  <button
                    type="button"
                    className="them_btn_ouline "
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="them_btn1 "
                    onClick={handleSubmit}
                  >
                    {uploadSpin ? <SpinnerCircular /> : " Send Invite"}
                  </button>
                </div>

                {/* <div class="modal-footer border-top-0">
                  <button
                    type="button"
                    class="them_btn_ouline "
                    className="them_btn_ouline "
                  >
                    Cancel
                  </button>
                  <button type="button" class="them_btn ">
                    {uploadSpin ? (
                      <SpinnerCircular  />
                    ) : (
                      " Send Invite"
                    )}
                  </button>
                </div> */}
              </>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default DropdownRight;
